import createIcon from '../../createIcon';

/**
 * @component @name SimCard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOTkgNEMxOS45OSAyLjkgMTkuMSAyIDE4IDJIMTBMNCA4VjIwQzQgMjEuMSA0LjkgMjIgNiAyMkgxOC4wMUMxOS4xMSAyMiAyMCAyMS4xIDIwIDIwTDE5Ljk5IDRaTTkgMTlIN1YxN0g5VjE5Wk0xNyAxOUgxNVYxN0gxN1YxOVpNOSAxNUg3VjExSDlWMTVaTTEzIDE5SDExVjE1SDEzVjE5Wk0xMyAxM0gxMVYxMUgxM1YxM1pNMTcgMTVIMTVWMTFIMTdWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SimCard = createIcon('SimCard', [
  [
    'path',
    {
      d: 'M19.99 4C19.99 2.9 19.1 2 18 2H10L4 8V20C4 21.1 4.9 22 6 22H18.01C19.11 22 20 21.1 20 20L19.99 4ZM9 19H7V17H9V19ZM17 19H15V17H17V19ZM9 15H7V11H9V15ZM13 19H11V15H13V19ZM13 13H11V11H13V13ZM17 15H15V11H17V15Z',
      key: '67h1bn',
    },
  ],
]);

export default SimCard;
